



























































import { Component, Vue } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class'
import { AuthState, LoginPayload } from "../types";
import { GET_LOGIN_ERROR, LOGIN, LOADING_LOGIN, FULLNAME } from "../store/constants";
import Loader from "@/shared/components/ui/Loader.vue";
import LoadableButton from "@/shared/components/ui/LoadableButton.vue";

@Component({
    components: {
        Loader,
        LoadableButton
    },
})
export default class Login extends Vue {
    @Action(LOGIN) login!: any;
    @Getter(LOADING_LOGIN) loading!: string;
    @Getter(GET_LOGIN_ERROR) loginError!: boolean;

    private loginInfo: LoginPayload = {
        email: "",
        password: "",
    };

    private errors: string[] = [];

    private checkForm() {
        if (
            this.loginInfo.email &&
            this.loginInfo.password
        ) {
            return true;
        }

        this.errors = [];

        if (!this.loginInfo.email) {
            this.errors.push('El correo electrónico es obligatorio.');
        }

        if (!this.loginInfo.password) {
            this.errors.push('La contraseña es obligatoria.');
        }

    }

    private async handleSubmit() {
        const formValid = this.checkForm();

        if (!formValid) {
            this.errors.forEach((error: string) => {
                (this as any).$notify({
                    group: 'errors',
                    title: 'Error',
                    text: error,
                    type: 'error',
                });
            });
            return
        }

        await this.login(this.loginInfo);
    }

    mounted() {
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
    }
}
